import React from 'react';
import styled from 'styled-components';

import GuestLayout from '../Layout/GuestLayout';
import { vh100 } from '../../config/css';
import { useTranslation } from '../../helpers/hooks';
import { SkeddyImage } from '../../common/Carousel';
import { LayoutWrapper } from '../../core/pages/update/styled';
import { Link } from '../../common/Link';
import {
  registerHelpCreateRequestClickEvent,
  registerHelpFaqClickEvent,
  registerHelpFBClickEvent,
} from '../../services/reactGa';
import { faqLink, fbLink } from '../../config/urls';
import { Button } from '../../common/styled/form';
import { AltText } from '../../core/pages/help/styled';
import { eventsService } from '../../services/EventsService';

const MainContainer = styled.div`
  height: calc(${vh100});
  position: relative;
`;

const MainText = styled.div`
  text-align: center;
  margin-top: 25px;
  margin-bottom: 25px;
  line-height: 22px;
  font-size: 20px;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 30px;
  line-height: 32px;
  text-align: center;
  margin: 25px 0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  justify-content: start;
  height: inherit;

  margin: 0 auto;

  h1 {
    font-weight: normal;
    text-align: center;
    margin: 24px 0 18px 0;
    font-size: 52px;
    color: ${(props) => props.theme.altText};
  }

  h2 {
    font-weight: normal;
    text-align: center;
    margin: 0 0 18px 0;
    color: ${(props) => props.theme.textColor};
  }
`;

const buttonStyle = {
  maxWidth: 320,
  width: '100%',
  display: 'inline-block',
  padding: '10px 20px',
  fontSize: 16,
  marginBottom: 20,
};

export function ClosedIos() {
  const { t } = useTranslation();

  const handleShowSupportModal = () => {
    registerHelpCreateRequestClickEvent();
    eventsService.showSupportModal();
  };

  return (
    <LayoutWrapper style={{ position: 'absolute', top: 0, zIndex: 100 }}>
      <GuestLayout style={{ backgroundSize: '20vh' }} allowToDrivers>
        <MainContainer>
          <Container>
            <Title>{t('pages.closedIos.title')}</Title>
            <MainText>
              {t('pages.closedIos.body1')}
              <br />
              <br />
              {t('pages.closedIos.body2')}
              <br />
              <br />
              <div style={{ marginTop: 'auto', textAlign: 'center' }}>
                <SkeddyImage />
              </div>
            </MainText>
            <MainText>
              <Link onClick={registerHelpFaqClickEvent} href={faqLink}>
                <Button style={buttonStyle}>{t('pages.closedIos.faq')}</Button>
              </Link>
              <Link onClick={registerHelpFBClickEvent} href={fbLink}>
                <Button style={buttonStyle}>{t('pages.closedIos.fb')}</Button>
              </Link>
              <AltText style={{ marginTop: 20 }}>{t('pages.closedIos.needHelp')}</AltText>
              <Link onClick={handleShowSupportModal}>
                <Button
                  style={{
                    ...buttonStyle,
                    width: 180,
                  }}
                >
                  {t('pages.closedIos.helpDesk')}
                </Button>
              </Link>
            </MainText>
          </Container>
        </MainContainer>
      </GuestLayout>
    </LayoutWrapper>
  );
}
